import { render } from "./ThongTinChieuVe.vue?vue&type=template&id=65714d4b&scoped=true"
import script from "./ThongTinChieuVe.vue?vue&type=script&lang=js"
export * from "./ThongTinChieuVe.vue?vue&type=script&lang=js"

import "./ThongTinChieuVe.vue?vue&type=style&index=0&id=65714d4b&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65714d4b"]])

export default __exports__